// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__327V4","log":"ModalInventoryLogs_log__V25dR","date":"ModalInventoryLogs_date__2kGIZ","userName":"ModalInventoryLogs_userName__1w_7B"};